import React from 'react';
import { connect } from 'react-redux';

// Components
import Anchor from 'Components/common/Anchor';
import AdventProductCard from 'Components/host/AdventProductCard'

// Actions
import { getAdventInventorDetail } from 'Actions/host';
import { openNotification } from 'Actions/notification';
import { getAllSkuConditionList } from 'Actions/host';

// Icons
import { ArrowBackIos } from '@material-ui/icons';
import { T } from 'Actions/translate';
import LoadingIcon from 'Components/icons/LoadingIcon';

class AdventProductDetails extends React.Component {
    state = {
        orderDetails: {},
        products: {},
        isShowPrice: true,
        expressNumber: '',
        submitBtnLoaded: true,
        f1OrderShipData: [],
        confirmShipData: [],
        shipExitOpened: false,
        AdventInventorList: [],
        listLoaded: true
    }

    componentWillMount() {
        this.getAdventInventoryDetail();
    }

    getAdventInventoryDetail = () => {
        let routeState = this.props.history.location.state;
        let scId = '';
        if (routeState && typeof routeState.scId !== 'undefined') {
            scId = routeState.scId;
        }
        this.props.getAdventInventorDetail({scId: scId}).then(res => {
            if(res && res.status === 'success')

                this.setState({
                    AdventInventorList: res.data,
                    listLoaded: false
                });
        }).catch((res) => {
            this.setState({
                AdventInventorList: res.data,
                listLoaded: true
            });
        });
    };

    goBack = () => {
        this.props.history.replace('/AdventProductsSCList')
    }

    inputValid = (key, value, item) => {
        let products = this.state.products;

        products[item.id] = products[item.id] || {};
        products[item.id][key] = value;

        this.setState({ products });
    }

    onChange = (title, value) => this.setState({ [title]: value })

    render() {
        const { AdventInventorList, listLoaded } = this.state;
        return (
            <div className="ship-edit-container">
                <div className="header-wrap">
                    <div className="ship-edit-header container-max-width is-fixed">
                        <Anchor className="go-back" onClickOfSingleTap={ () => this.goBack() }><ArrowBackIos/></Anchor>
                        {T('host_advent_products_details_header')}
                    </div>
                </div>
                { listLoaded ? <LoadingIcon className="circle-animation"/> : <div className="products">
                    {
                        AdventInventorList && AdventInventorList.map(item => {
                            return (
                                <AdventProductCard key={ item.id } adventProducts={ item } adventInventoryDetail={this.getAdventInventoryDetail}/>
                            );
                        })
                    }
                  </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { host } = state;
    return {
        adventInventoryDetails: host.adventInventoryDetails
    };
};

const mapDispatchToProps = {
    getAdventInventorDetail,
    openNotification,
    getAllSkuConditionList
};

export default connect(mapStateToProps, mapDispatchToProps)(AdventProductDetails);
